<section class="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-950 to-slate-900 pt-32 pb-24">
  <!-- Animated Background Elements -->
  <div class="absolute inset-0 overflow-hidden">
    <!-- Gradient Orbs -->
    <div class="absolute top-20 left-10 w-96 h-96 bg-primary-500/15 rounded-full mix-blend-multiply filter blur-3xl animate-pulse-slow"></div>
    <div class="absolute top-40 right-10 w-96 h-96 bg-accent-500/15 rounded-full mix-blend-multiply filter blur-3xl animate-pulse-slow" style="animation-delay: 2s;"></div>
    <div class="absolute -bottom-8 left-1/2 w-96 h-96 bg-primary-400/15 rounded-full mix-blend-multiply filter blur-3xl animate-pulse-slow" style="animation-delay: 4s;"></div>
  </div>

  <!-- Content -->
  <div class="container-max relative z-10 text-center">
    <div class="space-y-8 animate-fade-in-up">
      <!-- Badge -->
      <div class="inline-block">
        <span class="px-4 py-2 bg-primary-500/20 border border-primary-400/40 text-primary-200 rounded-full text-sm font-semibold backdrop-blur-sm">
          ✨ Building Excellence Since 2010
        </span>
      </div>

      <!-- Main Headline -->
      <h1 class="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight drop-shadow-lg">
        <span class="block">Building Trust.</span>
        <span class="gradient-text-inline block pt-2 pb-2">Creating Landmarks.</span>
      </h1>

      <!-- Subheading -->
      <p class="text-xl lg:text-2xl text-slate-300 max-w-2xl mx-auto leading-relaxed">
        Premium residential and commercial construction solutions crafted with precision, innovation, and uncompromising quality.
      </p>

      <!-- CTA Buttons -->
      <div class="flex flex-col sm:flex-row gap-4 justify-center pt-8">
        <a 
          routerLink="/projects"
          class="px-8 py-4 bg-gradient-to-r from-primary-600 to-accent-500 text-white font-bold rounded-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 group"
        >
          View Projects
        </a>
        <a 
          routerLink="/contact"
          class="px-8 py-4 border-2 border-primary-400 text-primary-300 font-bold rounded-lg hover:bg-primary-500/10 transition-all duration-300 flex items-center justify-center gap-2 group"
        >
          Get In Touch
        </a>
      </div>
    </div>

  </div>
</section>
